export default {
  DANG_NHAP: "/auth/login",
  DANG_NHAP_CAPTCHA: "/auth/login_captcha",
  REFRESH_TOKEN: "/auth/refresh-token",
  VAN_BAN: {
    GET_DANH_SACH_TAI_LIEU_HO_SO: 'quanlyvanban/danhsachhoso',
    THEM_TAI_LIEU_VAO_HO_SO: 'quanlyvanban/themtailieu',
    THEM_CONG_VIEC_VAO_HO_SO: 'quanlyvanban/themcongviec',
    LOAI_SO: {
      GET_LOAI_VAN_BAN: "/loaisovanban/get-loai-van-ban",
      GET_DANH_SACH_LOAI_SO_PAGING: "/loaisovanban/search",
      GET_DANH_SACH_LOAI_SO: "/loaisovanban/get-all",
      SUA_LOAI_SO: "/loaisovanban/sua",
      XOA_LOAI_SO: "/loaisovanban/xoa",
      THEM_LOAI_SO: "/loaisovanban/them",
    },
    SO_VAN_BAN: {
      OPTION_DON_VI: "/sovanban/get-opt-don-vi",
      THEM_SO: "/sovanban/them",
      SUA_SO: "/sovanban/sua",
      XOA_SO: "/sovanban/xoa",
      DANH_SACH_SO: "/sovanban/get-all",
      DANH_SACH_SO_PAGING: "/sovanban/search",
    },
    SAO_CHEP_SO: (Id) => `/sovanban/sao-chep/${Id}`,
    TRA_CUU_LAY_LAI_VAN_BAN: (id) => `/vanban/tra-cuu-lay-lai-van-ban/${id}`,
  },
  DANH_MUC: {
    DANH_SACH_TRANG_THAI_CONG_VIEC: "/dm/trang-thai/trangthaicv",
  },
  NHIEM_VU: {
    GET_NHIEM_VU_PAGING: "/qlnv/nhiem-vu/all",
    GET_TAT_CA_DON_VI_TRONG_DON_VI_CHA: "/dm/don-vi/cha/1",
    GET_TAT_CAT_CAN_BO_TRONG_DON_VI: "/dm/can-bo/all?donViId=",
    GET_TAT_CAT_CAN_BO_CO_QUYEN_PHAN_XU_LY_TRONG_DON_VI:
      "/dm/can-bo/all-phan-xu-ly?donViId=6",
    TAO_MOI: "/qlnv/nhiem-vu/them",
    THEM_MOI_VAN_VAN_BAN_LIEN_QUAN: "/qlnv/van-ban-lien-quan/update",
    THEM_MOI_FILE: "/Common/UploadMultiFile",
    THEM_MOI_VAN_VAN_BAN_LIEN_QUAN_:
      "/qlnv/van-ban-lien-quan/update-danh-sach-van-ban",
    THEM_MOI_ONE_FILE: "/qlnv/upload-file/upload-one-file",
    DOWNLOAD_FILE: "/api/qlnv/upload-file/download-file",
    THEM_MOI_Y_KIEN_XU_LY: "/qlnv/y-kien-xu-ly/update",
    LAY_DANH_SACH_NGUOI_GIAO_NV: "/qlnv/nhiem-vu/nguoi-giao/",
    NHOM_NHIEM_VU_XOA: "/qlnv/nhiem-vu/xoa?id=",
    CHI_TIET_NHIEM_VU: "/qlnv/nhiem-vu/get",
    CHI_TIET_VAN_BAN_LIEN_QUAN: "/qlnv/van-ban-lien-quan/",
    CHI_TIET_Y_KIEN_XU_LY: "/qlnv/y-kien-xu-ly/",
    GET_LOAI_NHIEM_VU: "/qlnv/loai-nhiem-vu/getall",
    GET_TAT_CA_LOAI_NHIEM_VU: "/qlnv/loai-nhiem-vu/get-all-khong-phan-quyen",
    UP_LOAD_FILE: "/Uploads",
    CAP_NHAT_NHIEM_VU: "/qlnv/nhiem-vu/sua",
    CAP_NHAP_VAN_BAN_LIEN_QUAN_NHIEM_VU: "/qlnv/van-ban-lien-quan/update",
    CAP_NHAP_Y_KIEN_XU_LY_NHIEM_VU: "/qlnv/y-kien-xu-ly/",
    THEM_Y_KIEN_XU_LY: "qlnv/buoc-xu-ly/them",
    THU_HOI_NHIEM_VU: "/qlnv/thu-hoi/thu-hoi",
    LAY_DANH_SACH_THU_HOI_NHIEM_VU:
      "/qlnv/thu-hoi/get-don-vi-thu-hoi?nhiemVuId=",
    TRA_LAI_NHIEM_VU: "/qlnv/nhiem-vu/tra-lai-nhiem-vu",
    TRA_LAI_NHIEM_VU_CHINH_PHU: "/qlnv/nhiem-vu/tra-lai-vpcp",
    LAY_DANH_SACH_TRA_LAI_NHIEM_VU: "/qlnv/nhiem-vu/nguoi-tra-lai",
    DON_DOC_NHIEM_VU: "/qlnv/nhiem-vu/don-doc",
    CAP_NHAT_TINH_HINH_NHIEM_VU: "/qlnv/nhiem-vu/cap-nhat-tinh-hinh",
    SO_LUONG_NHIEM_VU: "/qlnv/nhiem-vu/so-luong",
    DANH_SACH_NHIEM_VU: "/qlnv/nhiem-vu/get-all",
    DANH_SACH_TRANG_THAI: "/dm/trang-thai/get-all",
    GET_DON_VI_CA_NHAN: "/qlnv/phan-xu-ly/get-all-don-vi",
    PHAN_XU_LY: "/qlnv/phan-xu-ly/phan-xu-ly",
    CAP_NHAT_TU_DONG_HOAN_THANH: "/qlnv/phan-xu-ly/cap-nhat-tu-dong-hoan-thanh",
    GET_PHAN_XU_LY_BY_NHIEM_VU_ID:
      "/qlnv/phan-xu-ly/get-by-nhiem-vu?nhiemVuId=",
    GET_PHAN_DON_VI_XU_LY: "/qlnv/phan-xu-ly/get-all-don-vi",
    GET_DON_VI_XU_LY_NHIEU: "/qlnv/phan-xu-ly/don-vi-phan-xu-ly",
    GET_PHAN_DON_VI_XI_LY_ES: "/qlnv/phan-xu-ly/get-all-don-vi-es",
    GET_PHAN_DON_VI_XU_LY_CHILDREN: "/qlnv/phan-xu-ly/get-don-vi-child",
    UPDATE_PHAN_XU_LY: "/qlnv/phan-xu-ly/cap-nhat-phan-xu-ly",
    LAY_DANH_SACH_LICH_SU_PHAN_SU_LY:
      "/qlnv/phan-xu-ly/getbynhiemvu?nhiemVuId=",
    LAY_TRANG_THAI_TINH_HINH_THUC_HIEN: "/dm/trang-thai/tinh-hinh-thuc-hien",
    LAY_TRANG_THAI_CHO_DUYET_HOAN_THANH: "/dm/trang-thai/cho-duyet-hoan-thanh",
    THEM_MOI_TINH_HINH_THUC_HIEN: "/qlnv/tinh-hinh-thuc-hien/them-moi",
    CAP_NHAT_VBLQ_TINH_HINH_THUC_HIEN:
      "/qlnv/van-ban-lien-quan/cap-nhat-tinh-hinh-thuc-hien",
    THEM_VBLQ_TINH_HINH_THUC_HIEN:
      "/qlnv/van-ban-lien-quan/them-van-ban-cap-nhat-tinh-hinh-thuc-hien",
    LAY_TINH_HINH_THUC_HIEN_NHIEM_VU:
      "/qlnv/tinh-hinh-thuc-hien/get-by-nhiem-vu",
    LAY_TINH_HINH_THUC_HIEN_CONG_VIEC:
      "/qlnv/tinh-hinh-thuc-hien/get-by-cong-viec",
    // LAY_DANH_SACH_PHUONG_THUC_NHAN_NHIEM_VU: "/qlnv/phuong-thuc-nhan/get",
    LAY_DANH_SACH_PHUONG_THUC_NHAN_NHIEM_VU: "/danh-muc/getallphuongthucnhan",
    LAY_DANH_SACH_LICH_SU_TRA_LAI: "/qlnv/nhiem-vu/lich-su-tra-lai/",
    LAY_DANH_SACH_LICH_SU_CAP_NHAT_TINH_HINH:
      "/qlnv/nhiem-vu/tinh-hinh-thuc-hien/",
    LAY_DANH_SACH_LICH_SU_VPCP_DON_DOC: "/qlnv/nhiem-vu/lich-don-doc-vpcp/",
    LAY_DANH_SACH_LICH_SU_GUI_TRA_VPCP: "/qlnv/nhiem-vu/lich-gui-tra-vpcp/",
    LAY_DANH_SACH_TIEN_DO_VPCP: "/qlnv/nhiem-vu/tien-do-xu-ly-vpcp/",
    LAY_DANH_SACH_DIEU_CHINH_VPCP: "qlnv/nhiem-vu/lich-gui-dieu-chinh-vpcp/",
    LAY_DANH_SACH_LICH_SU_THU_HOI: "/qlnv/thu-hoi/lich-su-thu-hoi?nhiemVuId=",
    LAY_DANH_SACH_LICH_SU_DON_DOC: "/qlnv/nhiem-vu/lich-su-don-doc?nhiemVuId=",
    LAY_DANH_SACH_DEM_LOAI_NHIEM_VU_CA_NHAN:
      "/qlnv/nhiem-vu/dem-loai-nhiem-vu/canhan",
    LAY_DANH_SACH_DEM_LOAI_NHIEM_VU_DON_VI:
      "/qlnv/nhiem-vu/dem-loai-nhiem-vu/donvi",
    LAY_DANH_SACH_DEM_LOAI_CONG_VIEC: "/qlnv/cong-viec/dem-loai-cong-viec",
    LAY_DANH_SACH_DEM_LOAI_CONG_VIEC_DV:
      "/qlnv/cong-viec/dem-loai-cong-viec-don-vi",
    LAY_DANH_SACH_SO_DO_LUONG_NHIEM_VU: "/qlnv/nhiem-vu/luong-xu-ly?nhiemVuId=",
    LAY_DANH_SACH_SO_DO_LUONG_NHIEM_VU_V2:
      "/qlnv/nhiem-vu/luong-xu-ly-v2?nhiemVuId=",
    LAY_DANH_SACH_DEM_LOAI_CONG_VIEC_DON_VI: "/qlnv/nhiem-vu/nhiem-vu-qua-han",
    GET_EXPORT_FILE: "/qlnv/nhiem-vu/get-export-result",
    DOWNLOAD_FILE_EXPORT: "/qlnv/nhiem-vu/download-file-export",
    XOA_NHIEM_VU: "/qlnv/nhiem-vu/xoa",
    GET_DANH_SACH_NHIEM_VU_FROM_IMPORT_FILE:
      "/qlnv/nhiem-vu/upload-file-import",
    KIEM_THU_IMPORT_FILE: "/qlnv/nhiem-vu/kiem-thu-import",
    IMPORT_FILE: "/qlnv/nhiem-vu/import-nhiem-vu",
    GET_COT_NHIEM_VU_EXPORT: "qlnv/nhiem-vu/get-column",
    THEM_MOI_EXPORT_TEMPLATE: "qlnv/nhiem-vu/them-export-template",
    GET_NHIEM_VU_EXPORT_TEMPLATE: "qlnv/nhiem-vu/get-export-template",
    GUI_LAI_VPCP_NHIEM_VU: "/qlnv/nhiem-vu/danh-dau-nhiem-vu-gui-vpcp",
    SUA_Y_KIEN_NHIEM_VU: "/qlnv/y-kien-xu-ly/sua",
    XOA_Y_KIEN_NHIEM_VU: "qlnv/y-kien-xu-ly/xoa",
    GET_TASK_PHAN_XU_LY_ID: "/qlnv/nhiem-vu/get-current-task",
    DS_DONVI_DA_PHAN_XU_LY: "/qlnv/phan-xu-ly/get-don-vi-da-phan-xu-ly",
    TRA_LAI_CONG_VIEC: "/qlnv/nhiem-vu/tra-lai-cong-viec",
    YEU_CAU_GIA_HAN_VPCP: "/qlnv/nhiem-vu/yeu-cau-gia-han-nhiem-vu-vpcp",
    UPDATE_VAN_BAN_LQ: "/qlnv/van-ban-lien-quan/update",
  },
  NHOM_CHUC_VU: {
    TAO_MOI: "/DanhMuc/ApiNhomChucVu.svc/Insert",
    NHOM_CHUC_VU_PAGING: "/DanhMuc/ApiNhomChucVu.svc/GetNhomChucVuPaging?",
    NHOM_CHUC_VU_CHI_TIET_ID:
      "/DanhMuc/ApiNhomChucVu.svc/GetNhomChucVuTheoId?id=",
    NHOM_CHUC_VU_CAP_NHAT: "/DanhMuc/ApiNhomChucVu.svc/Update",
    NHOM_CHUC_VU_XOA: "/DanhMuc/ApiNhomChucVu.svc/Delete?id=",
  },
  CONG_VIEC: {
    GET_CONG_VIEC_PAGING: "/qlnv/cong-viec/search",
    GET_CONG_VIEC_CA_NHAN: "/qlnv/cong-viec/danhsachcongvieccanhan",
    LAY_DANH_SACH_CV_BY_NHIEM_VU: "/qlnv/cong-viec/dsbynhiemvu?nhiemVuId=",
    LAY_DANH_SACH_DON_VI_TAO_CONG_VIEC: "/qlnv/cong-viec/dsdonvitaocv",
    LAY_DANH_SACH_DON_VI_GAN_CONG_VIEC: "/qlnv/cong-viec/dsdonvigancv",
    TAO_MOI: "/qlnv/cong-viec/them",
    GET_CHI_TIET_CONG_VIEC: "/qlnv/cong-viec/chitiet?congViecId=",
    XOA_CONG_VIEC: "/qlnv/cong-viec/xoa",
    HUY_CONG_VIEC: "/qlnv/cong-viec/huy",
    SUA_CONG_VIEC: "/qlnv/cong-viec/sua",
    GAN_CONG_VIEC: "/qlnv/cong-viec/assigncongviec",
    LAY_DANH_SACH_LICH_SU_THAY_DOI_TRANG_THAI:
      "/qlnv/cong-viec/lichsuthaydoitrangthai",
    LAY_DANH_SACH_LICH_SU_GIAO_VIEC: "/qlnv/cong-viec/lichsugiaoviec",
    LAY_DANH_SACH_MUC_DO_CONG_VIEC: "/qlnv/cong-viec/get-muc-do-cong-viec",
  },
  AUTH: {
    SET_CURRENT_DON_VI: "/auth/setcurrentdonvi",
    GET_DON_VI_CURRENT_USER: "/auth/getdonvicurrentuser",
    LAY_DANH_SACH_PHAM_VI: "/auth/get-pham-vi",
    LAY_HO_TEN_CAN_BO: "/auth/get-ho-ten-user",
    PERMISSION: "/auth/get-permissions",
  },
  // UC7.4: quản lý thiết bị xác thực của CHÍNH user (gọi common-be trực tiếp qua HTTP_COMMON).
  // list-device: self (Bearer, không userId). set-primary: đặt TB chính (Bearer, không step-up).
  OTP_DEVICE: {
    LIST_DEVICE: "/TwoFactorAuthenticator/list-device",
    SET_PRIMARY: "/TwoFactorAuthenticator/set-primary",
    // Self-service gỡ thiết bị kẹt ChoKichHoat của chính mình (Bearer, step-up OTP trong payload).
    REVOKE_MY_DEVICE: "/TwoFactorAuthenticator/revoke-my-device",
    // Gỡ thiết bị Active CUỐI -> BE tắt 2FA về chưa-bật. KHÔNG nhận OTP (scheme "2FA", chấp token stage-1).
    SELF_REVOKE_DEVICE: "/TwoFactorAuthenticator/self-revoke-device",
    // UC7.4 (2026-08-19): thêm thiết bị thứ N qua QR handoff post-login (Bearer full common-be trực tiếp).
    MINT_ADD_DEVICE_TICKET: "/TwoFactorAuthenticator/mint-add-device-ticket",
    GET_PENDING_ENROLL: "/TwoFactorAuthenticator/get-pending-enroll",
    CONFIRM_ENROLL_BINDING: "/TwoFactorAuthenticator/confirm-enroll-binding",
    // Self-unlock qua email dự phòng (plan 260819-1524): user tự mở khóa thiết bị Locked của mình
    // (Bearer post-login). Bước 1 xin mã email; bước 2 nhập mã -> Locked->Active.
    REQUEST_MY_UNLOCK_CODE: "/TwoFactorAuthenticator/request-my-unlock-code",
    CONFIRM_MY_UNLOCK: "/TwoFactorAuthenticator/confirm-my-unlock",
    // Self-lock (đối chiếu D58): user tự khóa thiết bị Active của mình (Active->Locked, Bearer, KHÔNG email).
    // BE chặn khóa thiết bị Active cuối. Mở lại bằng "Mở khóa qua email" (row 57) hoặc QTHT.
    LOCK_MY_DEVICE: "/TwoFactorAuthenticator/lock-my-device",
  },
  THONG_BAO: {
    GET_ALL: "/qlvb/van-ban-den/thong-bao/get-all",
    UPDATE_DA_XEM: "/qlvb/van-ban-den/thong-bao/update-daxem",
    MARK_AS_READ_ALL: "/qlvb/van-ban-den/thong-bao/mark-as-read-all",
  },
  QUAN_TRI_HE_THONG: {
    TEMPLATE: {
      NAME: "/dm/template",
      GET_ALL: "/dm/template/search",
      SUA: "/dm/template/sua",
      XOA: "/dm/template/xoa",
      THEM_MOI: "/dm/template/them",
      CHI_TIET: "/dm/template/chitiet",
    },
    GET_DANH_SACH_QUAN_LY_HE_THONG_LOG: "/common/getlogs",
    GET_DANH_SACH_DANH_MUC_CRUD: "/danh-muc/get-all",
    GET_DANH_SACH_DANH_MUC_CRUD_BY_CODE: "/danh-muc/get-by-code",
    THEM_MOI_DANH_MUC_CRUD_BY_CODE: "/danh-muc/them-item",
    XOA_DANH_MUC_CRUD_BY_CODE: "/danh-muc/xoa-item",
    SUA_DANH_MUC_CRUD_BY_CODE: "/danh-muc/sua-item",
    DON_VI_NGOAI: {
      GET_DANH_SACH_DON_VI_NGOAI: "/donvingoai/get-all",
      GET_DANH_SACH_DON_VI_NGOAI_PAGING: "/donvingoai/search",
      THEM_DON_VI_NGOAI: "/donvingoai/them",
      SUA_DON_VI_NGOAI: "/donvingoai/sua",
      XOA_DON_VI_NGOAI: "/donvingoai/xoa",
      SEARCH: "/donvingoai/search",
    },
    DANH_MUC_LOAI_HO_SO: "/hslt/loai-ho-so/get-all",
    GET_DANH_SACH_DE_MUC: "/hslt/de-muc/get-all",
    SUA_DE_MUC: "/hslt/de-muc/edit",
    GET_DANH_SACH_LINH_VUC: "/hslt/linh-vuc/get-all",
    GET_LIST_YEAR_FILTER: "/hslt/get-list-year-filter",
    GET_BY_CURRENT_PHONG_BAN: "/hslt/linh-vuc/get-by-current-phong-ban",
    THEM_MOI_LINH_VUC: "/hslt/linh-vuc/create",
    SUA_LINH_VUC: "/hslt/linh-vuc/edit",
    LIST_PHONG_BAN: "/hslt/linh-vuc/get-list-donvi-phongban",
    CHI_TIET_LINH_VUC: "/hslt/linh-vuc/get-by-id",
    XOA_LINH_VUC: "/hslt/linh-vuc/delete",
    XOA_MULTI_LINH_VUC: "/hslt/linh-vuc/delete-range",
    NHOM_LAM_VIEC: {
      NAME: "/nhom-lam-viec-van-ban-di",
      UPDATE: "/nhom-lam-viec-van-ban-di/update",
      SEARCH: "/search",
      CHI_TIET: "/get-chi-tiet",
      XOA_DON_VI_CA_NHAN: "/delete-object",
      THEM_DON_VI_CA_NHAN: "/insert",
      COPY: "/nhom-lam-viec-van-ban-di/copy/",
    },
    CAU_HINH: {
      SEARCH: "/config/search",
      UPDATE: "/config/update",
      DONG_BO_CHUNG: "/config/dong-bo-danh-muc-chung",
      DONG_BO_CAN_BO: "/config/dong-bo-du-lieu-can-bo",
    },
    DON_VI_NOP_LUU: {
      SEARCH_TREE: "/hslt/don-vi-gui-nhan/search-tree",
      GET_DON_VI_NHAN: "/hslt/don-vi-gui-nhan/get-don-vi-nhan",
      GET_DON_VI_GUI: "/hslt/don-vi-gui-nhan/get-don-vi-gui",
      THEM: "/hslt/don-vi-gui-nhan/them",
      XOA_DON_VI_GUI: "/hslt/don-vi-gui-nhan/xoa-don-vi-gui",
      HAS_DAI_DIEN_BO: "/hslt/don-vi-gui-nhan/has-dai-dien-bo",
    },
    // Cấu hình ủy quyền
    DS_UY_QUYEN: "/cau-hinh-uy-quyen/danh-sach",
    THAY_DOI_UY_QUYEN: "/auth/thay-doi-uy-quyen",
    GET_NGUOI_UY_QUYEN: "/cau-hinh-uy-quyen/nguoi-uy-quyen",
    GET_DON_VI_UY_QUYEN: "/cau-hinh-uy-quyen/don-vi-uy-quyen",
    GET_NGUOI_DUOC_UY_QUYEN: (idNguoiUyQuyen) =>
      `/cau-hinh-uy-quyen/${idNguoiUyQuyen}/nguoi-duoc-uy-quyen`,
    GET_NGUOI_TAO_HO: (idNguoiUyQuyen) =>
      `/cau-hinh-uy-quyen/${idNguoiUyQuyen}/nguoi-tao-ho`,
    THEM_UY_QUYEN: "/cau-hinh-uy-quyen/them",
    SUA_UY_QUYEN: "/cau-hinh-uy-quyen/sua",
    XOA_UY_QUYEN: (Id) => `/cau-hinh-uy-quyen/${Id}`,
    // Danh sách ủy quyền
    DS_QL_UY_QUYEN: "/uy-quyen/danh-sach-uy-quyen", //XEM
    DS_DUOC_UY_QUYEN: "/uy-quyen/danh-sach-duoc-uy-quyen", // DS
    DS_GET_UY_QUYEN: "/uy-quyen/nguoi-uy-quyen",
    DS_GET_DUOC_UY_QUYEN: (idNguoiUyQuyen) =>
      `/uy-quyen/${idNguoiUyQuyen}/nguoi-duoc-uy-quyen`,
    THEM_QL_UY_QUYEN: "/uy-quyen/them",
    SUA_QL_UY_QUYEN: "/uy-quyen/sua",
    XOA_QL_UY_QUYEN: (Id) => `/uy-quyen/${Id}`,
    VI_TRI_UY_QUYEN: "/cau-hinh-uy-quyen/danh-sach-nguoi-uy-quyen",
  },
  DON_VI_NGOAI: {
    SEARCH: "/donvingoai/search",
    GET_MULTI: "/donvingoai/get-multi",
    SEARCH_IGNORE: "/donvingoai/search-ignore",
  },
  DON_VI_TRONG: {
    SEARCH: "/don-vi-trong/search",
    PHAN_XU_LY_Y_KIEN: "/don-vi-trong/phan-xu-ly-y-kien",
    GET_MULTY: "/don-vi-trong/get-multi",
    BUILD_TREE: "/don-vi-trong/build-tree",
    SEARCH_IGNORE: "/don-vi-trong/search-ignore",
    SEARCH_DON_VI_TRONG_DON_VI_NGOAI: "/don-vi-trong/search-don-vi-trong-ngoai",
  },
  CAN_BO: {
    NAME: "/can-bo",
    CHI_TIET: "/can-bo/get-canbo-info",
    UPDATE_CAN_BO: "/update-profile",
    UPDATE_ANH: "/update-anh",
    UPLOAD: "/upload",
    UPDATE: "/add-or-update",
    SEARCH: "/can-bo/search",
    GET_MULTI: "/can-bo/get-multi",
    SEARCH_IGNORE: "/can-bo/search-ignore",
    SEARCH_VAN_THU: "/can-bo/search-van-thu",
    UPDATE_ANH_CAN_BO_COMMON: "/update-anh-can-bo-common",
  },
  LOAI_VAN_BAN: {
    SEARCH: "/loai-van-ban/search",
    GET_ALL: "/loai-van-ban/get-all",
    THEM: "/loai-van-ban/add",
    SUA: "/loai-van-ban/update",
    XOA: "/loai-van-ban/delete",
    GET_ALL_VAN_BAN: "/loai-van-ban/get-all-loai-van-ban",
    GET_ALL_VAN_BAN_MAC_DINH: "/loai-van-ban/get-default",
    CHI_TIET_LOAI_VAN_BAN: "/loai-van-ban/get-by-id",
  },
  DO_KHAN: {
    SEARCH: "/do-khan/search",
  },
  HO_SO_CONG_VIEC: {
    NAME: "/ho-so-cong-viec/",
    SEARCH: "/ho-so-cong-viec/search",
    Y_KIEN: "y-kien",
    EXPORT: "/ho-so-cong-viec/export",
    PHAN_XU_LY: "/phan-xu-ly",
    TRA_LAI: "tra-lai",
    THU_HOI: "thu-hoi",
    MO_LAI: "/mo-lai",
    KET_THUC: "/ket-thuc",
    LAY_DOI_TUONG_DUOC_TRA_LAI: "/get-doi-tuong-duoc-tra-lai",
    GET_TREE_DON_VI: "get-tree-don-vi",
    CAP_NHAT_THTH: "/cap-nhat-tinh-hinh-thuc-hien",
    GET_TREE_PHAN_XU_LY: "get-tree-don-vi",
    LICH_SU_THU_HOI: "/lich-su-thu-hoi",
    LICH_SU_PHAN_XU_LY: "/lich-su-phan-xu-ly",
    GET_LUONG_XU_LY: "/get-luong-xu-ly",
    LICH_SU_TRA_LAI: "/lich-su-tra-lai",
    LICH_SU_CAP_NHAT_TINH_HINH_THUC_HIEN: "/lich-su-cap-nhat",
    COUNT: "count",
    GET_TREE_DA_PHAN_XU_LY: "/get-tree-da-phan-xu-ly",
    CAP_NHAT_VAI_TRO_TREE_PXL: "/cap-nhat-vai-tro-tree-phan-xu-ly",
    DUYET: "/duyet",
    HUY_DUYET: "/huy",
    XIN_Y_KIEN: "/xin-y-kien",
    SET_DANG_PHAN_XU_LY: "/set-dang-phan-xu-ly",
    SET_DA_PHAN_XU_LY: "/set-da-phan-xu-ly-xong",
    HSCV_UPDATE_VB: "/ho-so-cong-viec-cap-nhat-van-ban/",
    HSCV_UPDATE_FILE: "/ho-so-cong-viec-cap-nhat-file/",
    DANH_SACH_Y_KIEN: "/ho-so-cong-viec/danh-sach-y-kien",
  },
  VAN_BAN_DI: {
    UPDATE_FILE: "update-file-van-ban-di",
    DELETE_FILE: "delete-file-van-ban-di",
    FILE_DINH_KEM: "/van-ban-di/file-dinh-kem",
    GET_DON_VI_CAN_BO: "/van-ban-di/get-don-vi-can-bo",
    CHO_TRINH_KY: "cho-trinh-ky",
    NAME: "/van-ban-di/",
    THEM_DON_VI_NGOAI: "donvingoai",
    SEARCH: "search",
    SEARCH_TRINH_BO: "search-trinh-bo",
    SEARCH_TRINH_BO_DA_DUYET: "search-trinh-bo-da-duyet",
    EXPORT_TRINH_BO: "export-trinh-bo",
    EXPORT_TRINH_BO_DA_DUYET: "export-trinh-bo-da-duyet",
    GET_MULTI: "get-multi-van-ban-di",
    CREATE: "/van-ban-di",
    UPLOAD_FILES: "/Common/UploadMultiFile",
    SO_LUONG: "so-luong",
    SO_LUONG_DASHBOARD: "so-luong-dashboard",
    DETAIL: "/van-ban-di/",
    THONG_TIN_CHUNG: "/van-ban-di-thong-tin-chung/",
    GUI_LAI_FILE_DON_VI: "/gui-lai-file-don-vi/",
    THONG_TIN_GUI_VAN_BAN: "/van-ban-di-thong-tin-gui-van-ban/",
    THONG_TIN_Y_KIEN: "/van-ban-di-thong-tin-y-kien/",
    UPDATE: "/van-ban-di/",
    UPDATE_DA_BAN_HANH: "/van-ban-di/cap-nhat-da-ban-hanh/",
    XIN_Y_KIEN: "/xin-y-kien",
    XOA_Y_KIEN: "/xoa-y-kien/",
    CHO_Y_KIEN: "/xin-y-kien/cho-y-kien",
    SUA_Y_KIEN: "/xin-y-kien/cho-y-kien",
    UPDATE_Y_KIEN: "/xin-y-kien",
    GET_LIST_VB_DEN: "/van-ban-di/danh-sach-van-ban-den",
    MULTI_VAN_BAN_DEN: "/van-ban-di/get-multi-van-ban-den",
    DUYET: "duyet",
    HUY_DUYET: "huy-duyet",
    HUY_TRINH_KY: "huy-trinh-ky",
    KY_SO_FILE: "/van-ban-di/ky-so-file/",
    CAP_SO: "/van-ban-di/cap-so",
    TRA_SO: "/van-ban-di/",
    NHAN_SO: "/van-ban-di/xin-so",
    DANH_SACH_NGUOI_DUOC_TRA_LAI: "/danh-sach-nguoi-duoc-tra-lai",
    TRA_LAI: "/tra-lai",
    LIST_XIN_SO: "/van-ban-di/xin-so/search",
    BAN_HANH: "ban-hanh",
    BAN_HANH_LEN_TRUC: "gui-lai-van-ban-len-truc",
    GUI_VAN_BAN_ERROR: "ban-hanh-lai-van-ban",
    KHONG_VAN_BAN_ERROR: "cap-nhat-khong-gui-lai",
    SAO_CHEP: "/van-ban-di/",
    BAN_HANH_BO_SUNG: "ban-hanh-bo-sung",
    TRINH_KY_TIEP_THEO: "/van-ban-di/",
    THU_HOI_DA_BAN_HANH: "/thu-hoi-da-ban-hanh",
    DON_VI_BAN_HANH: "/don-vi-ban-hanh",
    DON_VI_DA_BAN_HANH: "don-vi-da-ban-hanh",
    PHAN_XU_LY: "/phan-xu-ly",
    THU_HOI_SO: "/van-ban-di/xin-so/thu-hoi",
    LS_CAP_NHAT: "/xem-lich-su-cap-nhat",
    LS_TRA_LAI: "/xem-lich-su-tra-lai",
    LS_THU_HOI: "/xem-lich-su-thu-hoi",
    LS_HUY_DUYET: "/xem-lich-su-huy-duyet",
    LS_LIEN_THONG: "lich-su-theo-doi-lien-thong",
    LS_THEO_DOI_VAN_BAN: "/lich-su-theo-doi-van-ban",
    LUONG_XU_LY: "/xem-luong-xu-ly",
    LICH_SU_KY_DUYET: "/van-ban-di/",
    NGUOI_XU_LY_TIEP_THEO: "/nguoi-xu-ly-tiep-theo",
    THONG_TIN_KY_DUYET: "thong-tin-luong",
    EXPORT: "export",
    DOI_SO: "/doi-so",
    GAN_DON_VI_VAO_FILE: "/van-ban-di/",
    LAY_SO_DI_MAX: "sinh-so-tu-dong",
    LAY_FILE_VAN_BAN: "file-dinh-kem",
    GET_TREE_XIN_Y_KIEN: "/don-vi-trong/build-tree-lazy",
    XEM_KY_DIEN_TU: "xem-ky-dien-tu",
    CHECK_SO_DI: "/van-ban-di/check-so-di",
    CHECK_TRUNG_SO_DI: "/van-ban-di/check-trung-so-di",
    YEU_CAU_TRA_LAI: "/van-ban-di/cap-nhat-yeu-cau-tra-lai",
    SO_BI_GIU: "/cap-so-tu-dong/danh-sach-so-dang-giu",
    SINH_SO_NOI_BO: "/van-ban-di/sinh-so-tu-dong-noi-bo",
    DS_VAN_THU_LANH_DAO_XIN_SO_BO: "get-van-thu-lanh-dao-xin-so-bo"
  },
  LUONG: {
    SEARCH: "/luong-ky-duyet/all",
    CREATE: "/luong-ky-duyet",
    DELETE: "/luong-ky-duyet",
    INSERT: "/luong-ky-duyet/",
  },

  VAN_BAN_DEN: {
    UPDATE_DS_VAN_BAN: "update-danh-sach-van-ban",
    TIM_KIEM: "/vanban/TimKiem",
    GET_PHAN_DON_VI_XU_LY: "/qlvb/van-ban-den/phan-xu-ly/get-all-don-vi-es",
    GET_DON_VI_XIN_Y_KIEN:
      "/qlvb/van-ban-den/phan-xu-ly/get-don-vi-ca-nhan-xin-y-kien",
    GET_ALL_PHAN_DON_VI_XU_LY:
      "/qlvb/van-ban-den/phan-xu-ly/get-all-don-vi-web",
    PHAN_XU_LY: "/qlvb/van-ban-den/phan-xu-ly/phan-xu-ly",
    PHAN_XU_LY_NHIEU: "/qlvb/van-ban-den/phan-xu-ly/don-vi-phan-xu-ly",
    CHON_NGUOI_KY_DUYET: "/don-vi-trong/chon-nguoi-ky-duyet",
    CHON_NGUOI_XIN_Y_KIEN: "/don-vi-trong/chon-nguoi-xin-kien",
    GET_DASHBOARD_VAN_BAN_DEN: "/danh-muc/dashboard-van-ban-den",
    GET_SO_LUONG_VAN_BAN_DEN_ID: "/danh-muc/so-luong-van-ban-den-theo-id",
    DONG_NHAT_VAN_BAN: "/vanban/DongNhatVanBan",
    GET_DANH_SACH_VAN_BAN_DEN: "/vanban/getdanhsachvanban",
    GET_CHI_TIET_TRA_CUU_VAN_BAN_DEN: "/vanban/tra-cuu-van-ban-den-chi-tiet",

    //newmisson
    GET_LIST_NHOM_LAM_VIEC:
      "/qlvb/van-ban-den/phan-xu-ly/get-nhom-lam-viec-paging",
    GET_ALL_TRANG_THAI: "/danh-muc/getalltrangthai",
    GET_DANH_SACH_THU_HOI: "/thuhoi/GetDanhSachThuHoi",
    THU_HOI: "/thuhoi/ThuHoi",
    GET_DANH_SACH_TRA_LAI: "/qlvb/van-ban-den/nguoi-tra-lai?taskId=",
    TRA_LAI: "/qlvb/van-ban-den/tra-lai",
    XOA_VAN_BAN: "/vanban/xoa",
    GET_LOAI_VAN_BAN_DEN: "/VanBan/LoadOptionLoaiVB",
    GET_SO_VAN_BAN_DEN: "/sovanban/get-all-so-den",
    GET_PHUONG_THUC_NHAN_VAN_BAN: "/VanBan/LoadOptionPhuongThucNhanVanBan",
    GET_LOAI_VAN_BAN: "/VanBan/LoadOptionLoaiVB",
    GET_DO_KHAN: "/VanBan/LoadOptionDoKhan",
    GET_DON_VI_NGOAI: "/DonViNgoai/get-all",
    GET_OPT_DON_VI: "/don-vi-trong/get-opt-don-vi",
    GET_SO_DEN: "/SoVanBan/GetMaxSoDen",
    GET_CHI_TIET_VAN_BAN_DEN: "/VanBan/ChiTietVanBanDen",
    VAO_SO_VAN_BAN: "/VanBan/VaoSoVanBanGiay",
    SAO_CHEP_VAN_BAN: "/VanBan/clone-van-ban-den",
    VAO_SO_VAN_BAN_DIEN_TU: "/VanBan/VaoSoVanBanDienTu",
    CAP_NHAT_DANG_THUC_HIEN:
      "/qlvb/van-ban-den/tinh-hinh-thuc-hien/CapNhatDangThucHien",
    THEM_MOI_FILE: "/Common/UploadFile",
    THEM_MOI_NHIEU_FILE: "/Common/UploadMultiFile",
    LICH_SU_GUI_NHAN: "/VanBan/lich-su-gui-nhan",
    DANH_SACH_FILE: "/vanban/getdanhsachfile",
    DANH_SACH_FILE_BY_LIST_ID: "/vanban/getdanhsachfileByListId",
    LICH_SU_BY_TYPE: "/VanBan/lich-su-by-type",
    SO_VAN_BAN_DEN_MOI_NHAT: "/sovanban/get-so-van-ban-moi-nhat",
    LAY_SO_VAN_BAN: "/vanban/LaySo",
    BUT_PHE: "/qlvb/van-ban-den/y-kien-xu-ly/but-phe",
    LICH_SU_XIN_Y_KIEN_XU_LY:
      "/qlvb/van-ban-den/y-kien-xu-ly/lich-su-xin-y-kien",
    DANH_SACH_Y_KIEN: "/qlvb/van-ban-den/y-kien-xu-ly/danh-sach-y-kien",
    GET_NGUOI_CHO_Y_KIEN: "/qlvb/van-ban-den/y-kien-xu-ly/get-nguoi-cho-y-kien",
    GET_NGUOI_CHO_Y_KIEN_JSON:
      "/qlvb/van-ban-den/y-kien-xu-ly/get-nguoi-cho-y-kien-json",
    XIN_Y_KIEN_XU_LY: "/qlvb/van-ban-den/y-kien-xu-ly/xin-y-kien",
    THEM_MOI_Y_KIEN_XU_LY: "/qlvb/van-ban-den/y-kien-xu-ly/update-y-kien",
    SUA_Y_KIEN_NHIEM_VU: "/qlvb/van-ban-den/y-kien-xu-ly/sua",
    XOA_Y_KIEN_NHIEM_VU: "qlvb/van-ban-den/y-kien-xu-ly/xoa",
    XOA_XIN_Y_KIEN: "qlvb/van-ban-den/y-kien-xu-ly/xoa-xin-y-kien",
    XOA_TRA_LOI_Y_KIEN: "qlvb/van-ban-den/y-kien-xu-ly/xoa-tra-loi-xin-y-kien",
    XEM_LUONG_PHAN_XU_LY: "/vanban/getluongxuly?processId=",
    CAP_NHAT_HOAN_THANH_Y_KIEN: "/vanban/cap-nhat-hoan-thanh-nhieu-van-ban",
    CAP_NHAT_VAN_BAN_HOI_BAO: "/vanban/cap-nhat-hoi-bao-van-ban",
    SYNC_VAN_BAN_TU_TRUC: "/vanban/dong-bo-tu-truc",
    DOWNLOAD_EXPORT: "/qlvb/van-ban-den/bao-cao/export-van-ban",
    CHO_VAO_SO: "/VanBan/cho-vao-so",
    DANH_SACH_LANH_DAO_DON_VI: "/qlvb/van-ban-den/phan-xu-ly/get-lanh-dao",
    SCAN_VAN_BAN: "/extract-text?",
    QR_PDF: "/Common/AddQRCode",
    PREVIEW_FILE: "/Common/PreviewPDF",
    DANH_SACH_NHOM_LAM_VIEC: "/qlvb/van-ban-den/phan-xu-ly/get-nhom-lam-viec",
    CHO_Y_KIEN_TRA_LOI: "/qlvb/van-ban-den/y-kien-xu-ly/tra-loi-xin-y-kien",
    SUA_XIN_Y_KIEN: "/qlvb/van-ban-den/y-kien-xu-ly/sua-xin-y-kien",
    XOA_NHOM_LAM_VIEC: "/qlvb/van-ban-den/phan-xu-ly/xoa-nhom-lam-viec",
    SUA_NHOM_LAM_VIEC: "/qlvb/van-ban-den/phan-xu-ly/sua-nhom-lam-viec",
    GET_STATUS: "/vanban/trang-thai?taskId=",
    GET_SO_DEN_BY_DON_VI: "/sovanban/get-all-so-den-don-vi",
    GET_VAN_BAN_DI_RESPONSE: "/vanban/van-ban-di-response",
    TAO_NHOM_LAM_VIEC: "/qlvb/van-ban-den/phan-xu-ly/tao-nhom-lam-viec",
    MARK_AS_READ_LANH_DAO_BO: "/vanban/mark-as-read-by-lanh-dao-bo",
    TU_CHOI: "/qlvb/van-ban-den/tu-choi",
    DANH_SACH_DON_VI_CA_NHAN_DUOC_PHAN_XU_LY:
      "/qlvb/van-ban-den/phan-xu-ly/get-don-vi-da-phan-xu-ly",
    YEU_CAU_THU_HOI: "vanban/cap-nhat-thu-hoi-van-ban",
    THU_HOI_BAO_CAO_LANH_DAO: "vanban/thu-hoi-lanh-dao",
  },
  COMMON: {
    UPLOAD_MULTI_FILE: "Common/UploadMultiFile",
    GET_FILE_IN_FOLDER: "Common/GetFileInFolder",
    DOWNLOAD_FILE: "/Common/DownloadFile",
    ADD_QR_CODE: "Common/AddQRCode",
    KY_DIEN_TU: "sign/ky-dien-tu",
    PREVIEW_FILE: "/Common/PreviewPDF",
    SCAN_VAN_BAN: "/Common/ScanVanBan",
    GET_PHAN_HOI_MOI: "/Common/GetPhanHoiMoiNhat",
    GET_ACCESS_TOKEN: "/commonlogin/accessToken",
    GET_APP_ID: "/get-app-id",
    CHUYEN_VUNG: "/chuyen-du-lieu-ve-vung-luu-tru/",
    GET_IMAGE: "/FileObject/download-ftp",
    AUTHENTICATOR: {
      GENERATE_SETUP_CODE_2FA: '/auth/generate-setupcode-2fa',
      CONFIRM_USING_2FA: '/auth/confirm-using-2fa',
      VALIDATE_2FA: '/auth/validate-login-2fa',
      // Phase 08 Push Approval: qlvb-be proxy forward 2 endpoint mới common-be.
      POLL_LOGIN_APPROVAL: '/auth/poll-login-approval',
      COMPLETE_LOGIN: '/auth/complete-login',
      // P2 QR handoff: qlvb-be proxy 3 endpoint web-phiên (token stage-1).
      MINT_ENROLL_TICKET: '/auth/mint-enroll-ticket',
      GET_PENDING_ENROLL: '/auth/get-pending-enroll',
      CONFIRM_ENROLL_BINDING: '/auth/confirm-enroll-binding',
      // 1847 web QR-enroll email-verify: qlvb-be proxy request+verify mã email (token stage-1).
      OTP_ACTIVATION_REQUEST: '/auth/otp-activation-request',
      OTP_ACTIVATION_VERIFY: '/auth/otp-activation-verify',
    },
    GET_APP_CODE: '/App',
    GET_ACCES_TOKEN_IFRAME: 'CommonLogin/generateotplogin',
    DON_VI: {
      GET_TREE: 'donvi/get-tree?getAll=true',
    }
  },
  SO_VAN_BAN: {
    GET_ALL: "/sovanban/get-all-so-di",
    GET_ALL_DON_VI: "/sovanban/get-all-so-di-don-vi",
    GET_ALL_TRA_CUU: "/sovanban/get-all-so-di-tra-cuu",
  },
  BAO_BAO: {
    DANH_SACH_BAO_CAO: "qlvb/van-ban-den/bao-cao/search",
    DOWNLOAD_EXPORT: "/qlvb/van-ban-den/bao-cao/download-excel",
    DOWNLOAD_THONG_KE_EXPORT_VBD:
      "/qlvb/van-ban-den/bao-cao/download-thong-ke-excel",
    DANH_SACH_BAO_CAO_VAN_BAN_DI: "/van-ban-di/bao-cao",
    DANH_SACH_BAO_CAO_NHIEM_VU_TONG_HOP:
      "/qlnv/nhiem-vu/bao-cao-ket-qua-nhiem-vu",
    DANH_SACH_BAO_CAO_NHIEM_VU_CHI_TIET:
      "/qlnv/nhiem-vu/bao-cao-chi-tiet-nhiem-vu",
    DOWNLOAD_EXPORT_VAN_BAN_DI: "/van-ban-di/download-excel",
    BAO_CAO_SO_LUONG_DON_VI: "/vanban/bao-cao-so-luong-don-vi",
    DANH_SACH_BAO_CAO_SO_LUONG_VAN_BAN: "/vanban/bao-cao-van-ban",
    CHUYEN_DOI_SO: "vanban/bao-cao-danh-gia-muc-do-chuyen-doi-so",
    CHUYEN_DOI_SO_CHI_TIET:
      "vanban/bao-cao-danh-gia-muc-do-chuyen-doi-so-chi-tiet",
    NHIEM_VU_GIAO_BO:
      "qlnv/nhiem-vu/bao-cao-ket-qua-thuc-hien-nv-cp-tt-giao-bo",
    EXPORT_NHIEM_VU:
      "qlnv/nhiem-vu/bao-cao-ket-qua-thuc-hien-nv-cp-tt-giao-bo/export",
    EXPORT_CHI_TIET_NHIEM_VU: "qlnv/nhiem-vu/bao-cao-chi-tiet-nhiem-vu/export",
    DON_VI_NGOAI: "DonViNgoai/get-all?size=100",
  },
  WORD_ONLINE: {
    GET: "/word/get-word-file-qlvb",
    ADD_VERSION: "/word/add-version",
    GET_VERSION: "/get-word-file-all-versions",
  },
  EXCEL_ONLINE: {
    GET: "/excel/",
    ADD_VERSION: "/excel/add-version",
    GET_VERSION: "/get-excel-file-all-versions",
  },
  MAU_DU_THAO: {
    SEARCH: "/mau-du-thao/search",
    CHI_TIET: "/mau-du-thao/",
    SUA: "/mau-du-thao/",
    TAO: "/mau-du-thao",
    XOA: "/mau-du-thao/",
  },
  PAKN: {
    SEARCH_LOCATION: "/PAKN/get-don-vi",
    GET_DATA_DANH_MUC: "/PAKN/get-du-lieu-danh-muc",
    TAO_PAKN: "/PAKN/create-pakn",
    XEM_PAKN: "/PAKN/get-pakn",
    SEARCH_YEU_CAU: "/PAKN/search-yeu-cau",
    GET_LINH_VUC_PAKN: "/PAKN/get-du-lieu-danh-muc",
  },
  HSLT: {
    DOWNLOAD_MULTIFILE: "/Common/DownloadMultiFile",
    GET_DANH_SACH_HO_SO_DU_KIEN: "/hslt/ho-so-du-kien/get-danh-sach",
    GET_DANH_SACH_HO_SO: "/hslt/ho-so/get-danh-sach",
    GET_DANH_SACH_HO_SO_DU_KIEN_DON_VI: "/hslt/ho-so-du-kien/list-ho-so-don-vi",
    THEM_HO_SO_DU_KIEN: "/hslt/ho-so-du-kien/create",
    EDIT_HO_SO_DU_KIEN: "/hslt/ho-so-du-kien/edit",
    CHI_TIET_HO_SO_DU_KIEN: "/hslt/ho-so-du-kien/get-by-id",
    XOA_DANH_SACH_HS_DU_KIEN: "/hslt/ho-so-du-kien/delete",
    XOA_MULTI_HS_DU_KIEN: "/hslt/ho-so-du-kien/delete-range",
    GET_DANH_SACH_DANH_MUC_HO_SO: "/hslt/danh-muc-ho-so/search",
    DANH_SACH_CAN_BO_TRINH: "/hslt/danh-muc-ho-so/danh-sach-can-bo",
    LANH_DAO_DV_DUYET_HO_SO: "/hslt/danh-muc-ho-so/duyet",
    TRINH_LANH_DAO_DON_VI: "/hslt/danh-muc-ho-so/trinh-duyet",
    TRA_LAI_DANH_MUC_HO_SO: "/hslt/danh-muc-ho-so/tra-lai",
    CREATE_DANH_MUC_HO_SO: "/hslt/danh-muc-ho-so/create",
    EDIT_DANH_MUC_HO_SO: "/hslt/danh-muc-ho-so/edit",
    DANH_MUC_HO_SO: "/hslt/danh-muc-ho-so",
    GET_CAN_BO_NHAN_HO_SO_DU_KIEN: "/hslt/ho-so-du-kien/danh-sach-can-bo-nhan",
    GUI_DS_HO_SO_DU_KIEN: "/hslt/ho-so-du-kien/gui-danh-sach",
    GET_YEAR_FILTER: "/hslt/get-list-year-filter",
    LOAI_HO_SO: {
      GET_ALL: "/hslt/loai-ho-so/get-all",
    },
    NHOM_HO_SO: {
      GET_ALL: "/hslt/nhom-ho-so/get-all",
    },
    DE_MUC: {
      GET_ALL: "/hslt/de-muc/get-all",
    },

    CHI_TIET_DANH_MUC_HO_SO: "/hslt/danh-muc-ho-so/chi-tiet",
    DANH_SACH_Y_KIEN: (id) => `/hslt/danh-muc-ho-so/${id}/y-kien`,
    DON_VI_NOP_HO_SO: {
      GET_ALL: "/hslt/don-vi-nop/get-all-by-year",
      SEARCH: "/hslt/don-vi-nop/get-by-id",
      CREATE: "/hslt/don-vi-nop/create",
      DELETE: "/hslt/don-vi-nop/delete",
      MULTI_DELETE: "/hslt/don-vi-nop/delete-range",
      GET_ALL_DON_VI: "/hslt/don-vi-nop/get-all",
    },
    LAP_HO_SO: {
      CREATE: "/hslt/ho-so/create",
      UPLOAD_FILE: "/HoSo/UploadFile",
      GET_MA_HO_SO: "/hslt/get-ma-lien-thong",
    },
    Y_KIEN: {
      THEM: "/hslt/danh-muc-ho-so/y-kien/create",
      SUA: "/hslt/danh-muc-ho-so/y-kien/edit",
      XOA: (id) => `/hslt/danh-muc-ho-so/y-kien/${id}`,
    },
    LICH_SU_CHI_TIET_DANH_MUC_HO_SO: (id) =>
      `/hslt/danh-muc-ho-so/${id}/xem-lich-su-cap-nhat`,
    DANH_SACH_NGUOI_LAP_HO_SO: (id) => `/can-bo/don-vi/${id}`,
  },
  // UC14 Phase 5.3: proxy may-to-may qua qlvb-be (auth token qlvb-be) -> forward common-be internal.
  STEP_UP: {
    CHALLENGE: "/step-up/challenge",
    VERIFY: "/step-up/verify",
  },
  // Man Quan tri he thong > Tich hop TaskGov (qlvb-be TaskGovController, quyen quan-tri-he-thong).
  TASKGOV: {
    NHAT_KY_VAO: "/qlvb/taskgov/nhat-ky-vao",
    NHAT_KY_VAO_TONG_HOP: "/qlvb/taskgov/nhat-ky-vao/tong-hop",
    NHAT_KY_VAO_DU_LIEU: (id) => `/qlvb/taskgov/nhat-ky-vao/${id}/du-lieu`,
    NHAT_KY_VAO_DU_LIEU_TAI: (id) => `/qlvb/taskgov/nhat-ky-vao/${id}/du-lieu/tai`,
    // Phase 06: API cho nguoi xu ly (modal phan xu ly, danh sach, chi tiet van ban).
    CAU_HINH: "/qlvb/taskgov/cau-hinh",
    TRANG_THAI: "/qlvb/taskgov/trang-thai",
    LICH_SU: (processId) => `/qlvb/taskgov/lich-su/${processId}`,
    GUI_LAI: "/qlvb/taskgov/gui-lai",
    // Phase 06: API man quan tri (quyen quan-tri-he-thong).
    GIAO_VIEC: "/qlvb/taskgov/giao-viec",
    NHAT_KY_RA: "/qlvb/taskgov/nhat-ky-ra",
    NHAT_KY_RA_CHI_TIET: (id) => `/qlvb/taskgov/nhat-ky-ra/${id}`,
    NHAT_KY_RA_KET_QUA_DONG_BO: (id) => `/qlvb/taskgov/nhat-ky-ra/${id}/ket-qua-dong-bo`,
    CAN_BO: "/qlvb/taskgov/can-bo",
    KICH_HOAT: "/qlvb/taskgov/kich-hoat-tai-khoan",
    DONG_BO: "/qlvb/taskgov/dong-bo-danh-muc",
  },
};
